import { observable } from 'mobx';
import { SessionStore } from './Session';
import { IAuth } from './interface';
import { Actor, ActorSubclass, HttpAgent } from '@dfinity/agent';
import { Principal } from '@dfinity/principal';
import { WalletConnectError, WalletConnectErrorCode } from './utils/exception';
import { IC_HOST, isLocalEnv } from './utils/config';
import { IDL } from '@dfinity/candid';
import session from './Session';

export class AuthBase implements IAuth {
  @observable
  session: SessionStore;

  private static agent: HttpAgent;

  constructor() {
    this.session = session;
  }

  /**
   * create an actor
   * @param canisterId  canisterId
   * @param canisterDid  canisterDid
   * @param anonymous  create actor with anonymous identity
   * @returns
   */
  public async createActor<T>(
    canisterId: string,
    canisterDid: IDL.InterfaceFactory,
    anonymous: boolean = true
  ): Promise<ActorSubclass<T>> {
    if (!anonymous && !this.session.isConnected) {
      throw new WalletConnectError(
        WalletConnectErrorCode.NotConnected,
        'Wallet not connected'
      );
    }

    if (anonymous) {
      return this.createActorWithAnonymousIdentity(canisterId, canisterDid);
    }

    return await this.session.walletConnector.createActor(
      canisterId,
      canisterDid,
      this.session.walletAuth.type
    );
  }

  /**
   * create an actor with an anonymous identity
   * @param canisterDid
   * @param canisterId
   * @returns
   */
  private createActorWithAnonymousIdentity<T>(
    canisterId: string | Principal,
    canisterDid: IDL.InterfaceFactory
  ): ActorSubclass<T> {
    if (!AuthBase.agent) {
      AuthBase.agent = new HttpAgent({ host: IC_HOST });
      // The root key only has to be fetched for local development environments
      if (isLocalEnv()) {
        AuthBase.agent.fetchRootKey().catch(e => {
          console.error(`fetchRootKey error: ${e}`);
        });
      }
    }
    const actor = Actor.createActor<T>(canisterDid, {
      agent: AuthBase.agent,
      canisterId
    });

    return actor;
  }
}
